import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"
import Button from "components/presenters/common/form/Button"

export default function AddAddressBtn({ onClick }) {
  return (
    <AddBtn onClick={onClick} fullWidth>
      <PlusIconBlock>
        <SVGIcon name="plusIcon" />
      </PlusIconBlock>
      배송지 추가
    </AddBtn>
  )
}

const AddBtn = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  color: #4e4e4e;
  background-color: #f7f7f7;
  padding: calc(100vw * (16 / 375)) 0;
`

const PlusIconBlock = styled.div`
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (8 / 375));
  margin-right: calc(100vw * (7 / 375));

  svg {
    color: #4e4e4e;
  }
`
